<template>
  <form @submit.prevent="save" class="main-modal main-modal_w500 main-form">
    <div class="main-modal__title">
      <p v-if="!isUpdate">Todo erstellen</p>
      <p v-else>Todo aktualisieren</p>
    </div>

    <!-- {{ clientsData }} -->
    <div class="main-form__box" v-if="!isUpdate">
      <label class="main-form__label" for="">Kunden:</label>
      <el-select
        v-model="todo.client_id"
        placeholder="Kunden:"
        style="width:100%"
      >
        <el-option
          v-for="item in clients"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>

    <div class="main-form__box">
      <label class="main-form__label" for="">Kommentar</label>
      <textarea
        placeholder="Kommentar"
        class="main-form__textarea main-form__textarea_h80"
        v-model="todo.comment"
      ></textarea>
    </div>

    <div v-if="isUpdate" class="main-form__box">
      <p class="main-form__label mb-6" for="">Bezahlung</p>
      <div class="main-checkbox main-checkbox_flex">
        <input
          class="main-checkbox__input"
          type="checkbox"
          id="todo-1"
          v-model="todo.is_done"
        />
        <label for="todo-1" class="main-checkbox__label">
          <svg
            width="14"
            height="11"
            viewBox="0 0 14 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.44912 8.6786L1.13019 5.25802L0 6.41462L4.44912 11L14 1.1566L12.8778 0L4.44912 8.6786Z"
              fill="#9BCD82"
            />
          </svg>
        </label>
        <label class="main-checkbox__label-text" for="todo-1">
          <span v-text="'Todo abgeschlossen'"></span>
        </label>
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">{{
        $t("global.cancel")
      }}</span>
      <button
        type="submit"
        :disabled="!isChecked"
        class="main-button main-button_success"
      >
        {{ $t("global.save") }}
      </button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: {
        isUpdate: {
            required: true,
            type: Boolean,
        },
    },
    data() {
        return {
            clients: [],
        }
    },
    computed: {
        ...mapGetters({
            clientsData: 'clientsData',
            todo: 'todo/todo',
        }),
        isChecked() {
            return this.todo.comment.length >= 5
        },
    },
    methods: {
        ...mapActions({
            getClientsData: 'getClientsData',
        }),
        save() {
            this.$emit('done')
        },
        prepareClientSelect() {
            this.clientsData.forEach((element) => {
                this.clients.push({
                    label: `${element.first_name} ${element.last_name}`,
                    value: element.id,
                })
            })
        },
    },
    async mounted() {
        await this.getClientsData({})
        this.prepareClientSelect()
    // clients
    },
    beforeDestroy() {
        this.clients = []
    },
}
</script>
